import { FNode } from '../types/index.js';

import { getWorldPosition } from './getWorldPosition.js';

export const nodePositionHash = (node: FNode, useLocalPosition = false) => {
  const precision = 100;
  const p = useLocalPosition ? node.position : getWorldPosition(node);
  return `${Math.round(p[0] * precision)},${Math.round(p[1] * precision)}`;
};
